<template>
  <div class="tw-text-white">
    <div class="tw-flex tw-flex-wrap tw-bg-eko-blue tw-p-4">
      <div class="tw-w-full md:tw-w-1/2">
        <p>Welcome, it's nice to have you here</p>
        <p class="tw-mb-4">Here's an overview of your Eko Carbon Account</p>
      </div>
      <div class="tw-w-full md:tw-w-1/2  md:tw-float-right">
        <img
          class="md:tw-h-32 tw-object-contain tw-mx-auto md:tw-float-right md:tw-pr-8"
          src="https://res.cloudinary.com/dldd8ucby/image/upload/v1580816401/Eko%20Carbon/undraw_growth_analytics_8btt_1.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.v-application a {
  color: white;
}
</style>
